/**
 * drag 中の target badges が SVG 境界 (0, 0) - (width, height) を超えないよう
 * delta (dx, dy) を clamp する純関数。
 *
 * target badges の min/max 座標から許容 dx/dy 範囲を算出し、与えられた delta を
 * その範囲に丸める。和音のように複数 target が同時に動く場合は全体が境界に
 * 収まる最も厳しい値を採用する。
 */
export function clampBadgeDelta(
  targets: readonly { x: number; y: number }[],
  delta: { dx: number; dy: number },
  bounds: { width: number; height: number },
): { dx: number; dy: number } {
  if (targets.length === 0) return delta;

  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const t of targets) {
    if (t.x < minX) minX = t.x;
    if (t.x > maxX) maxX = t.x;
    if (t.y < minY) minY = t.y;
    if (t.y > maxY) maxY = t.y;
  }

  const dxMin = 0 - minX;
  const dxMax = bounds.width - maxX;
  const dyMin = 0 - minY;
  const dyMax = bounds.height - maxY;

  return {
    dx: Math.min(dxMax, Math.max(dxMin, delta.dx)),
    dy: Math.min(dyMax, Math.max(dyMin, delta.dy)),
  };
}
